/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2021 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import Button from "@material-ui/core/Button";

import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";

const ActionsModal = ({
  handleClose,
  open,
  title,
  message,
  handleAffirmative,
  handleNegative,
  affirmativeButtonText,
  negativeButtonText,
  disableBackdropClick = true,
  disableEscapeKeyDown = true,
}) => (
  <Dialog
    onClose={handleClose}
    open={open}
    maxWidth="xs"
    fullWidth={true}
    disableBackdropClick={disableBackdropClick}
    disableEscapeKeyDown={disableEscapeKeyDown}
    data-testid="actions-modal"
  >
    <MuiDialogTitle>{title}</MuiDialogTitle>
    <MuiDialogContent>{message}</MuiDialogContent>
    <MuiDialogActions>
      {handleNegative && negativeButtonText && (
        <Button
          variant="text"
          onClick={handleNegative}
          data-testid="actions-modal-negative-button"
        >
          {negativeButtonText}
        </Button>
      )}
      <Button
        variant="contained"
        onClick={handleAffirmative}
        data-testid="actions-modal-affirmative-button"
      >
        {affirmativeButtonText}
      </Button>
    </MuiDialogActions>
  </Dialog>
);

export default ActionsModal;
